
import React, { useEffect, useState } from "react";
import axiosApi from "../../Utils/axiosApi";

const ROOM_ACTIONS = [
  { label: "View Room Details", action: "details", icon: "▣" },
  { label: "View Room Schedule", action: "schedule", icon: "▦" },
  { label: "Mark for Maintenance", action: "maintenance", icon: "🔧" },
  { label: "Mark for Cleaning", action: "cleaning", icon: "✦" },
];

/*const ROOM_API_ENDPOINTS = {
  schedule: "/hostel/getRoomSchedule",
  maintenance: "/hostel/markRoomForMaintenance",
  cleaning: "/hostel/markRoomForCleaning",
};*/

export default function RoomContextMenu({
  menu,
  onClose,
  onAction,
  currentHostelId,
}) {
  const [loadingAction, setLoadingAction] = useState(null);
  const [apiError, setApiError] = useState("");

  useEffect(() => {
    if (!menu) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    const handleOutsideClick = () => {
      onClose();
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("click", handleOutsideClick);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("click", handleOutsideClick);
    };
  }, [menu, onClose]);

  if (!menu) return null;

  const room = menu.room;
  const roomNumber = room?.number ?? room?.roomNumber ?? "—";
  const roomId = room?.id ?? room?.roomId;

  const handleAction = async (action) => {
    if (loadingAction !== null) return;

    setApiError("");

    if (action === "details" && currentHostelId == null) {
      setApiError("Hostel ID is missing.");
      return;
    }

    if (
      ["schedule", "maintenance", "cleaning"].includes(action) &&
      roomId == null
    ) {
      setApiError("Room ID is missing for this action.");
      return;
    }

    setLoadingAction(action);

    try {
      let response;

    switch (action) {
  case "details": {
    response = await axiosApi.post("/public/getHostelRoom", {
      hostelSearchCriteria: {
        hostelIds: [Number(currentHostelId)],
        roomType: room?.roomType ?? "",
        roomNumber: roomNumber,
      },
    });
    break;
  }

 case "schedule": {
    /*response = await axiosApi.post("/hostel/getRoomSchedule", {
      hostelIds: [Number(currentHostelId)],
      roomType: room?.roomType ?? "",
      roomNumber: roomNumber,
    });*/
	
    break;
  }

  case "maintenance": {
   /* response = await axiosApi.post("/hostel/markRoomForMaintenance", {
      hostelIds: [Number(currentHostelId)],
      roomType: room?.roomType ?? "",
      roomNumber: roomNumber,
    });*/
    break;
  }

   case "cleaning": {
    /*response = await axiosApi.post("/hostel/markRoomForCleaning", {
      hostelIds: [Number(currentHostelId)],
      roomType: room?.roomType ?? "",
      roomNumber: roomNumber,
    });*/
    break;
  }


  default:
    return;
}

      console.log(`${action} API response:`, response?.data);

      // The room details API returns an array of room-type DTOs.
      // Pass the complete array to the parent; do not match by ID.
      const result =
        action === "details"
          ? Array.isArray(response?.data)
            ? response.data
            : Array.isArray(response?.data?.data)
              ? response.data.data
              : []
          : response?.data;

      if (action === "details" && result.length === 0) {
        setApiError("No room details were returned for this hostel.");
        return;
      }

      onAction?.(action, room, result);

      onClose();
    } catch (error) {
      console.error(`${action} API error:`, error);

      setApiError(
        error.response?.data?.message ||
          `Failed to ${
            action === "details"
              ? "load room details"
              : action === "schedule"
                ? "load room schedule"
                : action === "maintenance"
                  ? "mark room for maintenance"
                  : "mark room for cleaning"
          }.`
      );
    } finally {
      setLoadingAction(null);
    }
  };

  return (
    <div
      className="occ-context-menu"
      style={{
        position: "fixed",
        left: menu.x,
        top: menu.y,
        zIndex: 1000,
      }}
      role="menu"
      aria-label={`Room ${roomNumber} actions`}
      onClick={(event) => event.stopPropagation()}
      onContextMenu={(event) => event.preventDefault()}
    >
      <div className="occ-context-caption">
        Room {roomNumber}
      </div>

      {apiError && (
        <div
          role="alert"
          style={{
            padding: "8px 12px",
            color: "#d32f2f",
            fontSize: "12px",
            maxWidth: "240px",
          }}
        >
          {apiError}
        </div>
      )}

      {ROOM_ACTIONS.map(({ label, action, icon }) => (
        <button
          key={action}
          type="button"
          className="occ-context-menu__item"
          role="menuitem"
          disabled={loadingAction !== null}
          onClick={() => handleAction(action)}
        >
          <span className="occ-context-menu__icon" aria-hidden="true">
            {loadingAction === action ? "…" : icon}
          </span>

          <span>
            {loadingAction === action ? "Loading..." : label}
          </span>
        </button>
      ))}
    </div>
  );
}
